import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { Store } from '@ngrx/store';
import { SignalRService } from 'src/app/features/signal-r';
import { SigningRoomActions } from 'src/app/features/signing-room/store';
import { RootStoreState } from 'src/app/store';
import { delayedRetry } from 'src/app/operators';

@Injectable()
export class SigningRoomService {
  private listenerConfigured = false;

  constructor(
    private readonly http: HttpClient,
    private readonly signalRService: SignalRService,
    private readonly store: Store<RootStoreState.State>
  ) {}

  public attemptCompletion(packageUserGuid: string, deviceCode: string) {
    return this.http.post('closingroom/', {
      packageUserGuid,
      deviceCode,
    });
  }

  public sessionJoined(packageUserGuid: string, deviceCode: string) {
    return this.http
      .post('signingRoom/sessionJoined', {
        packageUserGuid,
        deviceCode,
      })
      .pipe(delayedRetry(1000, 3));
  }

  public triggerSigningCompletion(
    packageGuid: string,
    packageUserGuid: string,
    deviceCode: string
  ) {
    return this.http.post(`signingRoom/sessionCompletion`, {
      packageGuid,
      deviceCode,
      packageUserGuid,
    });
  }

  public getSigningStarted() {
    return this.http.get<{ hasSigningStarted: boolean }>('signingRoom/signingStarted', {});
  }

  public configureListeners() {
    if (!this.listenerConfigured) {
      this.listenerConfigured = true;

      this.signalRService.hubConnection.on('ReceiveSigningStarted', () => {
        this.store.dispatch(
          SigningRoomActions.SetSigningStartedStatus({
            payload: { hasSigningStarted: true },
          })
        );
      });

      this.signalRService.hubConnection.on(
        'ReceiveDisruptionNotificationToSigningAgent',
        (data) => {
          this.store.dispatch(
            SigningRoomActions.SendDisruptionNotificationToSigningAgent({
              payload: {
                title: data.title,
                message: data.message,
              },
            })
          );
        }
      );
    }
  }
}
